export interface ComicChapter {
  id: string;
  number: number;
  title: string;
  updateDate: string;
  pageCount: number;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  description: string;
  tags: string[];
  rating: number;
  views: number;
  chapters: ComicChapter[];
  status: '连载中' | '已完结';
  updateDate: string;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  count: number;
  description: string;
}

export const categories: Category[] = [
  { slug: 'lianai', name: '恋爱浪漫', icon: 'ri-heart-line', count: 128, description: '甜蜜浪漫的韩漫恋爱故事，让你感受心动瞬间' },
  { slug: 'qihuan', name: '奇幻冒险', icon: 'ri-magic-line', count: 96, description: '穿越异世界，魔法与冒险的奇幻之旅' },
  { slug: 'dongzuo', name: '动作热血', icon: 'ri-sword-line', count: 87, description: '热血战斗，激情对决，燃爆你的视觉体验' },
  { slug: 'xuanyi', name: '悬疑推理', icon: 'ri-search-eye-line', count: 64, description: '扣人心弦的悬疑故事，烧脑推理层层反转' },
  { slug: 'gaoxiao', name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: 73, description: '轻松搞笑的日常漫画，快乐解压每一天' },
  { slug: 'dushi', name: '都市生活', icon: 'ri-building-line', count: 82, description: '现代都市背景下的生活百态与情感纠葛' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '霸道总裁的契约新娘',
    author: '金智慧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%20art%20featuring%20elegant%20couple%20in%20formal%20attire%20soft%20warm%20coral%20pink%20and%20cream%20background%20with%20subtle%20sparkle%20effects%20clean%20modern%20illustration%20style%20no%20text%20romantic%20atmosphere%20dreamy%20lighting&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱浪漫',
    categorySlug: 'lianai',
    description: '林小曼本是一个普通上班族，却阴差阳错与霸道总裁签订了契约婚姻。本以为是逢场作戏，却在朝夕相处中渐生情愫。然而总裁的前女友突然回归，揭开了一段不为人知的往事...',
    tags: ['契约婚姻', '霸道总裁', '甜蜜', '都市', '韩漫'],
    rating: 9.2,
    views: 1250000,
    chapters: [
      { id: 'ch-1-1', number: 1, title: '命运的邂逅', updateDate: '2026-08-01', pageCount: 45 },
      { id: 'ch-1-2', number: 2, title: '契约签订', updateDate: '2026-08-02', pageCount: 42 },
      { id: 'ch-1-3', number: 3, title: '同居生活', updateDate: '2026-08-03', pageCount: 48 },
      { id: 'ch-1-4', number: 4, title: '心跳加速', updateDate: '2026-08-04', pageCount: 40 },
      { id: 'ch-1-5', number: 5, title: '前女友登场', updateDate: '2026-08-05', pageCount: 46 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
  },
  {
    id: 'comic-2',
    title: '异世界重生之最强魔法师',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20adventure%20comic%20cover%20featuring%20magician%20with%20glowing%20magic%20staff%20in%20mystical%20forest%20setting%20warm%20amber%20gold%20and%20emerald%20tones%20epic%20atmosphere%20clean%20illustration%20no%20text&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'qihuan',
    description: '天才魔法师韩宇在一次实验中意外身亡，醒来发现自己穿越到了平行世界。在这个魔法没落的时代，他凭借前世的知识，一步步走上最强魔法师的巅峰之路。',
    tags: ['穿越', '魔法', '冒险', '升级', '韩漫'],
    rating: 9.5,
    views: 2100000,
    chapters: [
      { id: 'ch-2-1', number: 1, title: '死亡的开始', updateDate: '2026-08-01', pageCount: 50 },
      { id: 'ch-2-2', number: 2, title: '新世界', updateDate: '2026-08-02', pageCount: 47 },
      { id: 'ch-2-3', number: 3, title: '魔法学院', updateDate: '2026-08-03', pageCount: 52 },
      { id: 'ch-2-4', number: 4, title: '入学考试', updateDate: '2026-08-04', pageCount: 44 },
      { id: 'ch-2-5', number: 5, title: '震惊全场', updateDate: '2026-08-05', pageCount: 49 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
  },
  {
    id: 'comic-3',
    title: '剑道至尊',
    author: '李东旭',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20martial%20arts%20comic%20cover%20featuring%20swordsman%20in%20dynamic%20battle%20pose%20with%20flowing%20cape%20warm%20coral%20and%20dark%20crimson%20tones%20intense%20atmosphere%20clean%20illustration%20no%20text%20dramatic%20lighting&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '动作热血',
    categorySlug: 'dongzuo',
    description: '孤儿出身的少年剑心，天生剑骨奇才。在一次意外中获得了上古剑道的传承，从此踏上成为剑道至尊的道路。面对各路强敌，他能否守护自己想要保护的一切？',
    tags: ['武侠', '剑道', '热血', '战斗', '韩漫'],
    rating: 9.3,
    views: 1890000,
    chapters: [
      { id: 'ch-3-1', number: 1, title: '剑心初醒', updateDate: '2026-08-01', pageCount: 43 },
      { id: 'ch-3-2', number: 2, title: '上古传承', updateDate: '2026-08-02', pageCount: 46 },
      { id: 'ch-3-3', number: 3, title: '初战强敌', updateDate: '2026-08-03', pageCount: 50 },
      { id: 'ch-3-4', number: 4, title: '突破极限', updateDate: '2026-08-04', pageCount: 41 },
    ],
    status: '连载中',
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-4',
    title: '密室逃脱：生死游戏',
    author: '崔敏静',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20thriller%20mystery%20comic%20cover%20featuring%20shadowy%20figure%20in%20dark%20room%20with%20cracked%20walls%20warm%20sepia%20and%20dark%20olive%20tones%20suspenseful%20atmosphere%20clean%20illustration%20no%20text%20moody%20lighting&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'xuanyi',
    description: '十个陌生人被关进一个密闭空间，必须在规定时间内解开层层谜题才能逃生。每一关都有人倒下，背后究竟隐藏着什么不可告人的秘密？谁是幕后黑手？',
    tags: ['密室', '悬疑', '推理', '生存', '韩漫'],
    rating: 9.1,
    views: 980000,
    chapters: [
      { id: 'ch-4-1', number: 1, title: '醒来', updateDate: '2026-08-02', pageCount: 48 },
      { id: 'ch-4-2', number: 2, title: '第一个谜题', updateDate: '2026-08-03', pageCount: 45 },
      { id: 'ch-4-3', number: 3, title: '牺牲者', updateDate: '2026-08-04', pageCount: 52 },
    ],
    status: '连载中',
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-5',
    title: '社畜的逆袭',
    author: '郑允儿',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20slice%20of%20life%20comic%20cover%20featuring%20office%20worker%20with%20funny%20expression%20in%20corporate%20setting%20warm%20peach%20and%20cream%20tones%20lighthearted%20atmosphere%20clean%20illustration%20no%20text&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'gaoxiao',
    description: '平凡上班族张大明每天在公司被老板压榨、被同事甩锅。直到有一天，他意外获得了"社畜系统"，可以用加班时间兑换各种神奇能力。逆袭之路从此开始！',
    tags: ['职场', '搞笑', '系统', '逆袭', '韩漫'],
    rating: 8.9,
    views: 1560000,
    chapters: [
      { id: 'ch-5-1', number: 1, title: '狗都不如的日子', updateDate: '2026-08-01', pageCount: 38 },
      { id: 'ch-5-2', number: 2, title: '系统激活', updateDate: '2026-08-02', pageCount: 42 },
      { id: 'ch-5-3', number: 3, title: '第一次试用', updateDate: '2026-08-03', pageCount: 40 },
      { id: 'ch-5-4', number: 4, title: '老板惊呆了', updateDate: '2026-08-04', pageCount: 44 },
      { id: 'ch-5-5', number: 5, title: '升职加薪', updateDate: '2026-08-05', pageCount: 41 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
  },
  {
    id: 'comic-6',
    title: '都市夜未眠',
    author: '韩素希',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20urban%20romance%20drama%20comic%20cover%20featuring%20stylish%20couple%20walking%20in%20city%20at%20night%20warm%20rose%20gold%20and%20deep%20navy%20tones%20romantic%20atmosphere%20clean%20illustration%20no%20text%20neon%20city%20lights&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '都市生活',
    categorySlug: 'dushi',
    description: '广告公司创意总监苏晚晴在事业巅峰期遭遇职场危机，与此同时，三个性格迥异的男人走进了她的生活。在都市的霓虹灯下，她该如何做出人生的选择？',
    tags: ['都市', '职场', '恋爱', '选择', '韩漫'],
    rating: 9.0,
    views: 1120000,
    chapters: [
      { id: 'ch-6-1', number: 1, title: '危机降临', updateDate: '2026-08-02', pageCount: 43 },
      { id: 'ch-6-2', number: 2, title: '命运的交汇', updateDate: '2026-08-03', pageCount: 47 },
      { id: 'ch-6-3', number: 3, title: '心动瞬间', updateDate: '2026-08-05', pageCount: 45 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
  },
  {
    id: 'comic-7',
    title: '纯情房东俏房客',
    author: '金贤秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romantic%20comedy%20comic%20cover%20featuring%20young%20man%20surrounded%20by%20cheerful%20female%20characters%20in%20cozy%20house%20setting%20warm%20apricot%20and%20soft%20yellow%20tones%20playful%20atmosphere%20clean%20illustration%20no%20text&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '恋爱浪漫',
    categorySlug: 'lianai',
    description: '大学生李浩然继承了爷爷留下的一栋大房子，却发现里面住着四个性格各异的漂亮女房客。本想卖掉房子的他，在与她们相处的过程中渐渐改变了主意...',
    tags: ['恋爱', '同居', '搞笑', '校园', '韩漫'],
    rating: 8.8,
    views: 870000,
    chapters: [
      { id: 'ch-7-1', number: 1, title: '继承遗产', updateDate: '2026-08-01', pageCount: 40 },
      { id: 'ch-7-2', number: 2, title: '四个房客', updateDate: '2026-08-03', pageCount: 44 },
      { id: 'ch-7-3', number: 3, title: '混乱的第一天', updateDate: '2026-08-05', pageCount: 42 },
    ],
    status: '已完结',
    updateDate: '2026-08-05',
  },
  {
    id: 'comic-8',
    title: '末日生存手册',
    author: '姜东元',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20post%20apocalyptic%20survival%20comic%20cover%20featuring%20survivor%20with%20backpack%20in%20ruined%20cityscape%20warm%20terracotta%20and%20dusty%20gray%20tones%20tense%20atmosphere%20clean%20illustration%20no%20text%20dramatic%20sky&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '动作热血',
    categorySlug: 'dongzuo',
    description: '一场突如其来的病毒席卷全球，感染者变成嗜血的怪物。退伍特种兵赵铁柱带着妹妹在末日中艰难求生，途中结识了各怀绝技的幸存者，组成了末日最强小队。',
    tags: ['末日', '生存', '丧尸', '热血', '韩漫'],
    rating: 9.4,
    views: 1980000,
    chapters: [
      { id: 'ch-8-1', number: 1, title: '爆发之日', updateDate: '2026-08-01', pageCount: 50 },
      { id: 'ch-8-2', number: 2, title: '逃离城市', updateDate: '2026-08-02', pageCount: 48 },
      { id: 'ch-8-3', number: 3, title: '幸存者营地', updateDate: '2026-08-03', pageCount: 52 },
      { id: 'ch-8-4', number: 4, title: '丧尸潮', updateDate: '2026-08-04', pageCount: 55 },
      { id: 'ch-8-5', number: 5, title: '绝地反击', updateDate: '2026-08-05', pageCount: 49 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
  },
  {
    id: 'comic-9',
    title: '公主的逆袭',
    author: '尹恩惠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20historical%20fantasy%20comic%20cover%20featuring%20elegant%20princess%20in%20ornate%20gown%20in%20royal%20palace%20warm%20champagne%20gold%20and%20soft%20rose%20tones%20regal%20atmosphere%20clean%20illustration%20no%20text&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'qihuan',
    description: '被陷害致死的公主重生回到三年前，带着前世的记忆，她决定不再做任人摆布的棋子。这一次，她要让所有背叛她的人付出代价，夺回属于自己的王位。',
    tags: ['重生', '宫廷', '逆袭', '复仇', '韩漫'],
    rating: 9.6,
    views: 2350000,
    chapters: [
      { id: 'ch-9-1', number: 1, title: '死亡与重生', updateDate: '2026-08-02', pageCount: 46 },
      { id: 'ch-9-2', number: 2, title: '回到三年前', updateDate: '2026-08-03', pageCount: 44 },
      { id: 'ch-9-3', number: 3, title: '第一步棋', updateDate: '2026-08-04', pageCount: 50 },
      { id: 'ch-9-4', number: 4, title: '朝堂风云', updateDate: '2026-08-05', pageCount: 48 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
  },
  {
    id: 'comic-10',
    title: '幽灵侦探事务所',
    author: '吴世勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20supernatural%20mystery%20comic%20cover%20featuring%20detective%20with%20ghostly%20companion%20in%20noir%20office%20setting%20warm%20sepia%20and%20ethereal%20blue%20tones%20mysterious%20atmosphere%20clean%20illustration%20no%20text&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'xuanyi',
    description: '能看见鬼魂的私家侦探林正浩开设了一家特殊的事务所。活人和死人的案件他都接。一桩看似普通的失踪案，却牵扯出了一桩跨越二十年的惊天大案。',
    tags: ['灵异', '侦探', '推理', '悬疑', '韩漫'],
    rating: 9.0,
    views: 765000,
    chapters: [
      { id: 'ch-10-1', number: 1, title: '第一单生意', updateDate: '2026-08-01', pageCount: 42 },
      { id: 'ch-10-2', number: 2, title: '失踪少女', updateDate: '2026-08-03', pageCount: 45 },
      { id: 'ch-10-3', number: 3, title: '幽灵的线索', updateDate: '2026-08-05', pageCount: 48 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
  },
  {
    id: 'comic-11',
    title: '咖啡店打工日记',
    author: '孙艺真',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cozy%20slice%20of%20life%20comic%20cover%20featuring%20barista%20in%20warm%20cafe%20interior%20with%20coffee%20and%20pastries%20warm%20caramel%20and%20creamy%20beige%20tones%20relaxing%20atmosphere%20clean%20illustration%20no%20text&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'gaoxiao',
    description: '艺术系大学生周小艺为了赚取学费在一家复古咖啡店打工。在这里，她遇到了各种奇葩顾客和温暖人心的故事，每一天都充满了欢笑与感动。',
    tags: ['咖啡店', '日常', '搞笑', '治愈', '韩漫'],
    rating: 8.7,
    views: 645000,
    chapters: [
      { id: 'ch-11-1', number: 1, title: '第一天上班', updateDate: '2026-08-02', pageCount: 38 },
      { id: 'ch-11-2', number: 2, title: '奇怪的客人', updateDate: '2026-08-04', pageCount: 40 },
    ],
    status: '连载中',
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-12',
    title: '重返十八岁',
    author: '刘在熙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20youth%20school%20life%20comic%20cover%20featuring%20high%20school%20students%20in%20uniform%20under%20cherry%20blossoms%20warm%20pink%20and%20soft%20sky%20tones%20nostalgic%20atmosphere%20clean%20illustration%20no%20text&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '都市生活',
    categorySlug: 'dushi',
    description: '四十岁的中年大叔意外重返十八岁，带着四十年的阅历重新体验青春。这一次，他要弥补所有的遗憾，追逐未完成的梦想，活出不一样的人生。',
    tags: ['重生', '青春', '校园', '梦想', '韩漫'],
    rating: 9.1,
    views: 1340000,
    chapters: [
      { id: 'ch-12-1', number: 1, title: '回到过去', updateDate: '2026-08-01', pageCount: 44 },
      { id: 'ch-12-2', number: 2, title: '重返校园', updateDate: '2026-08-02', pageCount: 46 },
      { id: 'ch-12-3', number: 3, title: '改变命运', updateDate: '2026-08-03', pageCount: 42 },
      { id: 'ch-12-4', number: 4, title: '初恋的味道', updateDate: '2026-08-05', pageCount: 48 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
  },
];